'use client';

import { DatePickerInput } from '@mantine/dates';
import * as React from 'react';

interface DatePickerMultiProps {
  count: number;
  value: (Date | undefined)[];
  onChange: (items: (Date | undefined)[]) => void;
  className?: string;
  disabled?: boolean;
}

function DatePickerMulti({
  value,
  onChange,
  className,
  disabled,
  ...props
}: DatePickerMultiProps) {
  const [dates, setDates] = React.useState<(Date | undefined)[]>(value);
  if (dates != undefined) {
    while (dates.length < props.count) {
      dates.push(undefined);
    }
  }

  return (
    <div>
      {dates != undefined &&
        dates.map((date, index) => (
          <DatePickerInput
            mt="md"
            placeholder="Pick a date"
            disabled={disabled}
            value={date}
            onChange={(new_date) => {
              if (new_date != undefined && dates.length > index) {
                dates[index] = new_date;
                setDates(dates);
                onChange(dates);
              }
            }}
          />
        ))}
    </div>
  );
}

export { DatePickerMulti };
